import Controller from '@ember/controller';
import { inject as service } from '@ember/service';
import { computed } from '@ember/object';
import { task } from 'ember-concurrency';

const CLASS_NAME = 'GLM-brand-signup-verify-email';

class SignupStepVerifyController extends Controller {
  @service('commands/user-commands') userCommandService;
  @service('error-tracker') errorTracker;
  @service session;

  get className() {
    return CLASS_NAME;
  }

  @computed('session.currentUser.email')
  get userEmail() {
    return this.session.currentUser.email;
  }

  @computed('resendVerificationEmail.last.error.errors.{email,newEmail,origin}')
  get resendVerifyEmailError() {
    if (!this.resendVerificationEmail.last) {
      return null;
    }

    const { error } = this.resendVerificationEmail.last;

    return error
      ? (error.errors?.email ?? 'There was a problem re-sending verification email.')
      : null;
  }

  @task
  *resendVerificationEmail() {
    const { currentUser } = this.session;

    try {
      yield this.userCommandService.resendVerifyEmail(currentUser.id, 'verify', currentUser.email);
    } catch (error) {
      this.errorTracker.error("resendVerificationEmail -- can't re-send verification email", this, error);
      throw error;
    }
  }
}

export default SignupStepVerifyController;
